<template>
  <div>    
    <div class="widget-container">

      <DxForm
        id="form"
        :form-data="state.formData"
        label-mode='outside'
        :read-only='false'
        :show-colon-after-label='true'
        label-location='top'
        :min-col-width='300'
        :col-count='1'
        ref="formMaster"
      >

      <DxTabbedItem :col-span="2">
          <DxTab title="Στοιχεία Ναύλου" :col-span="1" :col-count="1">
              <DxGroupItem caption="Ναύλωση" :col-span="12" :col-count="12">
                
          <DxSimpleItem 
              data-field="charter_agreement_id" 
              :editor-options="{
                                    mask: '00000000-00',
                                    maskChar: '_',
                                    maskRules: {
                                        'H': /[0-9A-Fa-f]/,
                                    },
                                    useMaskedValue: true,
                                }">
              <DxLabel text="Ναυλοσύμφωνο"/>
          </DxSimpleItem>

          <DxSimpleItem data-field = "charter_agreement_id_parent">
              <DxLabel 
                  text = "Προέλευση"
                  :editor-options = "{
                      disabled: true
                  }"/>
          </DxSimpleItem>

          <DxSimpleItem 
                data-field="charter_party_date"
                editor-type="dxDateBox"
                :col-span="2"
                :editor-options="dateBoxEditorOptions">
              <DxLabel text="Ημερομηνία"/>
          </DxSimpleItem>

          <DxSimpleItem data-field="charter_party_address" :col-span="3">
              <DxLabel text="Διεύθυνση"/>
          </DxSimpleItem>

          <DxSimpleItem
              data-field="user_id_allowed"
              editor-type="dxSelectBox"
              :col-span="2"
              :editor-options="{
                  dataSource: state.LookupCustomDS_j41ny_users,
                  searchEnabled: true,
                  displayExpr: 'name',
                  disabled: !this.allowAdministratorEditing,
                  showClearButton: true,
                  valueExpr:'id'
              }"
          >
            <DxLabel text="Υπάλληλος"/>
          </DxSimpleItem>

          <DxEmptyItem :col-span="3" />
          
          <DxSimpleItem data-field="ow_active_ind" editor-type="dxCheckBox">
              <DxLabel text="Ενεργό"/>
          </DxSimpleItem>

          <DxSimpleItem data-field="locked_ind" editor-type="dxCheckBox">
              <DxLabel text="Κλειδωμένο"/>
          </DxSimpleItem>

          <DxEmptyItem :col-span="10" />
        
                  <DxSimpleItem data-field="charter_period_from_date"
                      editor-type="dxDateBox"
                      :col-span="2"
                      :editor-options="dateBoxEditorOptions">
                      <DxLabel text="Από"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="charter_period_from_time"
                      editor-type="dxDateBox"
                      :editor-options="timeBoxEditorOptions">
                      <DxLabel text="Ώρα"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="charter_period_to_date"
                      editor-type="dxDateBox"
                      :col-span="2"
                      :editor-options="dateBoxEditorOptions">
                      <DxLabel text="Εώς"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="charter_period_to_time"
                      editor-type="dxDateBox"
                      :editor-options="timeBoxEditorOptions">
                      <DxLabel text="Ώρα"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="charter_period_days">
                      <DxLabel text="Ημέρες"/>
                  </DxSimpleItem>

                  <DxSimpleItem 
                      data-field="charter_extras_freeofcharge"
                      :col-span="5">
                      <DxLabel text="Extras Free of Charge / Εξτρας Χωρίς Χρέωση"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="charter_embarkation_port" :col-span="2">
                      <DxLabel text="Λιμένας Αναχώρησης"/>
                  </DxSimpleItem>

                  <DxEmptyItem :col-span="1" />

                  <DxSimpleItem data-field="charter_disembarkation_port" :col-span="2">
                      <DxLabel text="Λιμένας Επιστροφής"/>
                  </DxSimpleItem>

                  <DxEmptyItem :col-span="2" />

                  <DxSimpleItem 
                      data-field="charter_extras"
                      :col-span="5">
                      <DxLabel text="Extras / Εξτρας"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="signed_by_owner" editor-type="dxCheckBox" :col-span="2" >
                      <DxLabel text="Υπογραφή Πλοιοκτήτη"/>
                  </DxSimpleItem>
                          
                  <DxSimpleItem data-field="signed_by_broker" editor-type="dxCheckBox" :col-span="2" >
                      <DxLabel text="Υπογραφή Ναυλομεσίτη"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="signed_by_charterer" editor-type="dxCheckBox" :col-span="2" >
                      <DxLabel text="Υπογραφή Ναυλωτή"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="signed_by_representative" editor-type="dxCheckBox" :col-span="2" >
                      <DxLabel text="Υπογραφή Εκπροσώπου"/>
                  </DxSimpleItem>

              </DxGroupItem>

              <DxGroupItem caption="Στοιχεία Σκάφους" :col-span="2" :col-count="2">
                <DxGroupItem :col-span="4" :col-count="4">

                  <DxSimpleItem data-field="vessel_name" :col-span="2">
                      <DxLabel text="Όνομα Σκάφους"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_type" :col-span="2">
                      <DxLabel text="Τύπος Σκάφους"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_port_registry" :col-span="2">
                      <DxLabel text="Λιμάνι Νηολόγησης"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_registry_no">
                      <DxLabel text="Αριθμός"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_flag">
                      <DxLabel text="Σημαία"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_amepa">
                      <DxLabel text="Α.Μ.Ε.Π.Α."/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="electronic_register_number">
                      <DxLabel text="Αρ. Ηλ. Μητρώου"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="boat_professional_license_no" :col-span="2">
                      <DxLabel text="Αρ. Επαγγελματικής Άδείας Π.Α."/>
                  </DxSimpleItem>

                </DxGroupItem>
                
                <DxGroupItem  :col-span="5" :col-count="5">

                  <DxSimpleItem data-field="vessel_loa">
                      <DxLabel text="LOA"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_nrt">
                      <DxLabel text="NRT"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="vessel_grt">
                      <DxLabel text="GRT"/>
                  </DxSimpleItem>

                  <DxSimpleItem data-field="charter_max_persons_aboard" :col-span="2">
                      <DxLabel text="Μεγ. Αρ. Επιβατών"/>
                  </DxSimpleItem>

                  <DxSimpleItem
                      data-field="vessel_specifications"
                      editor-type="dxTextArea"
                      :editor-options="{ height: 120 }"
                      :col-span="3"
                  >
                      <DxLabel text="Χαρκτηριστικά"/>
                  </DxSimpleItem>

                </DxGroupItem>

              </DxGroupItem>
          </DxTab>

          <DxTab title="Στοιχεία Συναλλασομένων" :col-span="1" :col-count="1">

        <DxGroupItem caption="Στοιχεία Ναυλωτή" :col-span="9" :col-count="9">

        <DxSimpleItem
            data-field="charterer_name"
        >
            <DxLabel text="Ονοματεπώνυμο"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="charterer_address"
            :col-span="2"
        >
            <DxLabel text="Διεύθυνση"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="charterer_country_code_id"
          editor-type="dxSelectBox"
          :editor-options="{
              dataSource: state.LookupCustomDS_serres_country_codes,
              valueExpr:'country_code_id',
              displayExpr: 'country',
          }"
        >
          <DxLabel text="Χώρα"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="charterer_taxno"
        >
            <DxLabel text="ΑΦΜ"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="charterer_tax_office"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_tax_offices,
            displayExpr: 'name',
            valueExpr:'id'
          }"
        >
          <DxLabel text="ΔΟΥ"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="charterer_id_card_no"
        >
            <DxLabel text="Αρ.Ταυτότητας"/>
        </DxSimpleItem>


        <DxSimpleItem
            data-field="charterer_passport_no"
        >
            <DxLabel text="Αρ.Διαβατηρίου"/>
        </DxSimpleItem>

      </DxGroupItem>

      <DxGroupItem caption="Στοιχεία Εκπροσώπου" :col-span="9" :col-count="9">

        <DxSimpleItem
            data-field="vessel_representative_name"
        >
            <DxLabel text="Ονοματεπώνυμο/Επωνυμία"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_representative_address"
            :col-span="2"
        >
            <DxLabel text="Διεύθυνση"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="vessel_representative_country_code_id"
          editor-type="dxSelectBox"
          :editor-options="{
              dataSource: state.LookupCustomDS_serres_country_codes,
              valueExpr:'country_code_id',
              displayExpr: 'country',
          }"
        >
          <DxLabel text="Χώρα"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_representative_taxno"
        >
            <DxLabel text="ΑΦΜ"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="vessel_representative_tax_office"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_tax_offices,
            displayExpr: 'name',
            valueExpr:'id'
          }"
        >
          <DxLabel text="ΔΟΥ"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_representative_phone"
        >
            <DxLabel text="Αρ.Τηλεφώνου"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_representative_email"
        >
            <DxLabel text="Email"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_representative_contact_person"
        >
            <DxLabel text="Υπεύθυνος"/>
        </DxSimpleItem>

        <DxSimpleItem
              data-field="vessel_representative_bank_details"
              editor-type="dxTextArea"
              :col-span="3"
              :auto-resize-enabled="true"
        >
              <DxLabel text="Στοιχεία τραπεζικού λογαριασμού / ΙΒΑΝ"/>
        </DxSimpleItem>

      </DxGroupItem>

      <DxGroupItem caption="Στοιχεία Πλοιοκτήτη" :col-span="9" :col-count="9">

        <DxSimpleItem
            data-field="vessel_owner_name"
        >
          <DxLabel text="Ονοματεπώνυμο/Επωνυμία"/>

        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_owner_address"
            :col-span="2"
        >
            <DxLabel text="Διεύθυνση"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="vessel_owner_country_code_id"
          editor-type="dxSelectBox"
          :editor-options="{
              dataSource: state.LookupCustomDS_serres_country_codes,
              valueExpr:'country_code_id',
              displayExpr: 'country',
          }"
        >
          <DxLabel text="Χώρα"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_owner_taxno"
        >
            <DxLabel text="ΑΦΜ"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="vessel_owner_tax_office"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_tax_offices,
            displayExpr: 'name',
            valueExpr:'id'
          }"
        >
          <DxLabel text="ΔΟΥ"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_owner_phone"
        >
            <DxLabel text="Αρ. Τηλεφώνου"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="vessel_owner_email"
        >
            <DxLabel text="Email"/>
        </DxSimpleItem>

      </DxGroupItem>

      <DxGroupItem caption="Στοιχεία Ναυλομεσίτη" :col-span="9" :col-count="9">
          <DxSimpleItem
              data-field="broker_gr_name"
          >
            <DxLabel text="Ονοματεπώνυμο/Επωνυμία"/>
          </DxSimpleItem>

          <DxSimpleItem
              data-field="broker_gr_address"
              :col-span="2"
          >
              <DxLabel text="Διεύθυνση"/>
          </DxSimpleItem>

          <DxSimpleItem
            data-field="broker_gr_country_code_id"
            editor-type="dxSelectBox"
            :editor-options="{
                dataSource: state.LookupCustomDS_serres_country_codes,
                valueExpr:'country_code_id',
                displayExpr: 'country',
            }"
          >
            <DxLabel text="Χώρα"/>
          </DxSimpleItem>

          <DxSimpleItem
              data-field="broker_gr_taxno"
          >
              <DxLabel text="ΑΦΜ"/>
          </DxSimpleItem>

          <DxSimpleItem
            data-field="broker_gr_tax_office"
            editor-type="dxSelectBox"
            :editor-options="{
                dataSource: state.LookupCustomDS_serres_tax_offices,
                displayExpr: 'name',
                valueExpr:'id'
            }"
          >
            <DxLabel text="ΔΟΥ"/>
          </DxSimpleItem>

          <DxSimpleItem
              data-field="broker_gr_phone"
          >
              <DxLabel text="Αρ. Τηλεφώνου"/>
          </DxSimpleItem>

          <DxSimpleItem
              data-field="broker_gr_email"
          >
              <DxLabel text="Email"/>
          </DxSimpleItem>

          <DxEmptyItem :col-span="1" />
              
          <DxSimpleItem
              data-field="broker_gr_bank_details"
              editor-type="dxTextArea"
              :col-span="3"
              :auto-resize-enabled="true"
          >
              <DxLabel text="Στοιχεία τραπεζικού λογαριασμού / ΙΒΑΝ"/>
          </DxSimpleItem>

      </DxGroupItem>

      <DxGroupItem caption="Στοιχεία 2ου Πράκτορα" :col-span="9" :col-count="9">

        <DxSimpleItem
            data-field="broker_abroad_name"
        >
            <DxLabel text="Ονοματεπώνυμο/Επωνυμία"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="broker_abroad_address"
            :col-span="2"
        >
            <DxLabel text="Διεύθυνση"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="broker_abroad_country_code_id"
          editor-type="dxSelectBox"
          :editor-options="{
              dataSource: state.LookupCustomDS_serres_country_codes,
              valueExpr:'country_code_id',
              displayExpr: 'country',
          }"
        >
          <DxLabel text="Χώρα"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="broker_abroad_taxno"
        >
            <DxLabel text="ΑΦΜ"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="broker_abroad_tax_office"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_tax_offices,
            displayExpr: 'name',
            valueExpr:'id'
          }"
        >
          <DxLabel text="ΔΟΥ"/>
        </DxSimpleItem>

        </DxGroupItem>

        <DxGroupItem caption="Στοιχεία 3ου Πράκτορα" :col-span="9" :col-count="9">

        <DxSimpleItem
            data-field="broker_abroad_2_name"
        >
            <DxLabel text="Ονοματεπώνυμο/Επωνυμία"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="broker_abroad_2_address"
            :col-span="2"
        >
            <DxLabel text="Διεύθυνση"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="broker_abroad_2_country_code_id"
          editor-type="dxSelectBox"
          :editor-options="{
              dataSource: state.LookupCustomDS_serres_country_codes,
              valueExpr:'country_code_id',
              displayExpr: 'country',
          }"
        >
          <DxLabel text="Χώρα"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="broker_abroad_2_taxno"
        >
            <DxLabel text="ΑΦΜ"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="broker_abroad_2_tax_office"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_tax_offices,
            displayExpr: 'name',
            valueExpr:'id'
          }"
        >
          <DxLabel text="ΔΟΥ"/>
        </DxSimpleItem>

        </DxGroupItem>

        </DxTab>
      </DxTabbedItem>

        <DxSimpleItem
            data-field="google_map"
            :editor-options="{
                readOnly: true
            }"
        >
            <DxLabel text="Συντεταγμένες & Zoom"/>
        </DxSimpleItem>

      </DxForm>

      <div class="dx-fieldset-header">Μετάφραση Ονόματος Γεωγραφικής Τοποθεσίας</div>

      <div class="dx-fieldset">
        
                <DxDataGrid
                    :key-expr="id"
                    :data-source="state.CustomStoreGrid_serres_geo_locations_lang"
                    :columns="columns"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    :focused-row-enabled="true"
                    :width="gridWidth"
                    :style="{ 'max-width': maxWidth }"
                    ref="gridDetail_serres_geo_locations_lang"
                    :word-wrap-enabled="true"

                    @init-new-row="onInitNewRow"
                    @row-validating="onRowValidating"
                    v-model:focused-row-key="focusedRowKey"

                >
                <DxPaging 
                        :enabled="true"
                        :page-size="5"
                    />

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>
        
                    <DxPager
                        :visible="true"
                        :allowed-page-sizes="pageSizes"
                        :display-mode="displayMode"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                    />

                    <DxGroupPanel :visible="false"/>
                    <DxSorting mode="multiple"/>

                    <DxEditing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="true"
                        mode="batch"
                    />

                    <DxColumn
                        data-field="lang_id"
                        caption="Γλώσσα"
                    >
                        <DxLookup
                            :data-source="state.LookupCustomDS_serres_languages" 
                            value-expr="lang_id"
                            display-expr="title"
                        />
                        <DxRequiredRule message="Υποχρεωτικό πεδίο"/>
                    </DxColumn>

                    <DxColumn
                        data-field="descr"
                        caption="Περιγραφή"
                        :hiding-priority="110"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="short_descr"
                        caption="Σύντομη Περιγραφή"
                        :hiding-priority="120"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="search_descr"
                        caption="Περιγραφή για Αναζήτηση"
                        :hiding-priority="130"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="alias"
                        caption="Alias"
                        :hiding-priority="140"
                    >
                    </DxColumn>

                </DxDataGrid>

            </div>

            <div class="dx-fieldset-header">Εγκαταστάσεις Γεωγραφικής Τοποθεσίας</div>

            <div class="dx-fieldset">
  
                <DxDataGrid
                    :key-expr="id"
                    :data-source="state.CustomStoreGrid_serres_geo_location_facilities"
                    :columns="columns"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    :focused-row-enabled="true"
                    :width="gridWidth"
                    :style="{ 'max-width': maxWidth }"
                    ref="gridDetail_serres_geo_location_facilities"
                    :word-wrap-enabled="true"

                    @exporting="onExporting"
                    @rowClick="openForm"
                    @init-new-row="onInitNewRow"
                    @row-validating="onRowValidating"

                    v-model:focused-row-key="focusedRowKey"

                >
                <DxPaging 
                        :enabled="true"
                        :page-size="5"
                    />

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>
        
                    <DxPager
                        :visible="true"
                        :allowed-page-sizes="pageSizes"
                        :display-mode="displayMode"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                    />

                    <DxGroupPanel :visible="false"/>
                    <DxSorting mode="multiple"/>

                    <DxEditing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="true"
                        mode="batch"
                    />

                    <DxColumn
                        data-field="facility_type_id"
                        caption="Τύπος Εγκατάστασης"
                    >
                        <DxLookup
                            :data-source="state.LookupCustomDS_serres_geo_location_facility_types" 
                            value-expr="facility_type_id"
                            display-expr="description"
                        />
                        <DxRequiredRule message="Υποχρεωτικό πεδίο"/>
                    </DxColumn>

                    <DxColumn
                        data-field="description"
                        caption="Περιγραφή"
                        :hiding-priority="110"
                    >
                    </DxColumn>

                </DxDataGrid>

            </div>

            <div class="dx-fieldset-header">Γεωγραφική Τοποθεσία στον Χάρτη</div>
            <div class="map">
                  <GMapMap
                      :center="centerOfMap"
                      :zoom="zoom"
                      :options="{
                            zoomControl: true,
                            mapTypeControl: true,
                            scaleControl: true,
                            streetViewControl: true,
                            rotateControl: true,
                            fullscreenControl: true,
                      }"
                      ref="itieraryDetailMapRef"
                      map-type-id="terrain"
                      style="height: 500px"
                  >
                  <GMapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :draggable="true"
                    :position="m.position"
                    @dragend="onDragend"
                    :clickable="true"
                  />
                  </GMapMap>
                </div>

          <div id="buttons">
              <DxToolbar>
                  <dxItem 
                      location="after"
                      widget="dxButton"
                      @click="onClickSave"
                      :options="{
                          icon: 'save',
                          text: 'Αποθηκευση'
                      }"
                  >
                  </dxItem>
                  <dxItem 
                      location="after" 
                      widget="dxButton"
                      @click="onClickClose"
                      :options="{
                          icon: 'close',
                          text: 'Κλείσιμο'
                      }"
                      >
                  </dxItem>
              </DxToolbar>
        </div>
    </div>
</div>
</template>

<script>

  const URL_SERVICE = NYParameters.Host.URI + 'serres_charter_agreement'
  const URL_SERVICE_serres_country_codes = NYParameters.Host.URI + 'serres_country_codes'

  const URL_SERVICE_serres_tax_offices = NYParameters.Host.URI + 'serres_tax_offices'

  const URL_SERVICE_LOOKUP_serres_languages = NYParameters.Host.URI + 'serres_languages'

  const URL_SERVICE_LOOKUP_j41ny_users = NYParameters.Host.URI + 'j41ny_users_VIEW';
  
  //Grids
  //const URL_SERVICE_serres_geo_locations_lang = NYParameters.Host.URI + 'serres_geo_locations_lang'

  //SEQUENCE
  const URL_SERVICE_serres_geo_locations_nextval_VIEW = NYParameters.Host.URI + 'serres_geo_locations_nextval_VIEW'

  const centerOfGreece = { lat: 39.3643, lng: 21.9212 }

  import CustomStore from 'devextreme/data/custom_store';

  import { reactive, onMounted, computed } from 'vue';  
  import 'whatwg-fetch';

  import NYParameters from '../../ny-globals'


  import {
      DxForm, 
      DxLabel,
      DxSimpleItem, 
      DxEmptyItem,
      DxRequiredRule,
      DxGroupItem, 
      DxTabbedItem, 
      DxTab, 
      //DxButtonItem, 
      //DxButtonOptions
  } from 'devextreme-vue/form';

  import 'devextreme-vue/text-area';

  import DxDataGrid, {
      DxColumn,
      DxEditing, 
      DxPaging,
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      DxLookup, 
  } from 'devextreme-vue/data-grid';

  //import DxMap from 'devextreme-vue/map';
  
  //import DxDateBox from 'devextreme-vue/date-box';

  import DxToolbar from 'devextreme-vue/toolbar';

  export default {
    name: 'CharterAgreementForm',
    components: {
      //DxMap,
      DxForm,
      DxLabel,
      DxSimpleItem,
      DxEmptyItem,
      DxRequiredRule,
      DxDataGrid,
      DxColumn,
      DxEditing,
      DxPaging,
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      DxLookup,
      DxToolbar,
      DxGroupItem,
      //DxTextArea,
      DxTabbedItem, 
      DxTab, 
      //DxDateBox,
      // DxButtonItem, 
      // DxButtonOptions
    },
    data() {
        return {
            title: "Ναύλος",
            calendarOptions: { value: new Date() },
            textAreaOptions: { placeholder: 'Προσθήκη σχολίου..'},
            pageSizes: [5, 10, 20],
            GMAPIKey: NYParameters.googleMapsAPIKey,
            //dataGridRefKey: DATAGRIDREFKEY,
            dateBoxEditorOptions: {
              //pickerType: 'rollers',
              type: 'date',
              displayFormat: 'dd/MM/yyyy',
              dateSerializationFormat: 'yyyy-MM-dd',
              invalidDateMessage: 'Λάθος Ημερομηνία',
              showClearButton: true,
              max: new Date(2030, 11, 31)
            },

            timeBoxEditorOptions: {
              //pickerType: 'rollers',
              displayFormat: 'HH:mm',
              type: 'time',
              invalidDateMessage: 'Λάθος Ώρα',
              showClearButton: true,
            },

            rowIndex: -1,
            centerOfMap: centerOfGreece,
            zoom: 7,
            markers: [{
                position: centerOfGreece,
              }
            ]
        }
    },
    props: {
      charter_agreement_code: {
          type: Number,
          required: true
      }
    },
    watch: {
      charter_agreement_code(newValue, oldValue) {
          this.$emit('charter_agreement_code-value-changed', newValue, oldValue);
          this.loadFormData(newValue);
      }
    },
    setup(props) {
      const gridWidth = computed(() => '100%'); // set the width to 100%
      const maxWidth = computed(() => '1000px'); // set the max-width to 800px
      const state = reactive({
        formData: {},

        LookupCustomDS_serres_country_codes: new CustomStore({
            key: 'country_code_id',
            loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_country_codes + '?order=country'),
            byKey: (key) => sendRequestByKey(URL_SERVICE_serres_country_codes + "/" + encodeURIComponent(key)),
        }),

        LookupCustomDS_serres_tax_offices: new CustomStore({
            key: 'id',
            loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_tax_offices + '?order=name'),
            byKey: (key) => sendRequestByKey(URL_SERVICE_serres_tax_offices + "/" + encodeURIComponent(key)),
        }),

        serres_geo_locations_nextval_VIEW:  new CustomStore({
                key: 'id',
                loadMode: 'raw',
                cacheRawData: 'false',
                load: () => sendRequest(URL_SERVICE_serres_geo_locations_nextval_VIEW),
        }),

        LookupCustomDS_serres_languages:  new CustomStore({
            key: 'lang_id',
            loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_LOOKUP_serres_languages + '?order=title'),
            byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_serres_languages + "/" + encodeURIComponent(key)),
        }),

        LookupCustomDS_j41ny_users:  new CustomStore({
              key: 'id',
              loadMode: 'raw',
              load: () => sendRequest(URL_SERVICE_LOOKUP_j41ny_users + '?order=name'),
              byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_j41ny_users + "/" + encodeURIComponent(key)),
        }),

        CustomStoreMain: new CustomStore({
            key: 'charter_agreement_code',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE),
            insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequestByKey(URL_SERVICE + "/" + encodeURIComponent(key)),
        }),
      });

      // 
      //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
      //
      const sendRequest = (url, method = 'GET', values = {}) => {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          if (method === 'GET') {
                return fetch(url, {
                    method,
                    credentials: 'include',
                })
                .then(response => response.json())
                .then(json => {
                  return json.records;
                })
            }
            return fetch(url, {
                method,
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                credentials: 'include',
            }).then((result) => {
                if (result.ok) {
                    return result.text().then((text) => text && JSON.parse(text));
                }
                return result.json().then((json) => {
                    throw json.Message;
                });
            });
      };

      const sendRequestByKey = (url, method = 'GET') => {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          return fetch(url, {
                    method,
                    headers: {
                        'Accept': 'application/json',
                    },
                    credentials: 'include',
                })
                .then(response => response.json())
      };

      const saveData = async () => {
          // console.log('Save data');
          await state.CustomStoreMain.update(state.formData.charter_agreement_code, state.formData);
      };

      const insertData = async () => {
          // console.log('Insert data');
          await state.CustomStoreMain.insert(state.formData);
      };

      const clearForm = () => {
          state.formData = {};
      };

      var isGridValidated = true;
  
      onMounted(async () => {
          //state.formData = await state.CustomStoreMain.byKey(props.charter_agreement_code);
          if (props.charter_agreement_code != null) state.formData = await state.CustomStoreMain.byKey(props.charter_agreement_code);

      });

      return {
          saveData,
          insertData,
          clearForm,
          gridWidth,
          maxWidth,
          state,
          isGridValidated
      };
    },
    methods: {
        async loadFormData(id) {

            if (id != null) {
                this.isInsertMode = false
                this.state.formData = await this.state.CustomStoreMain.byKey(id)

                this.setMapMarker(this.state.formData.google_map)

            } else {
                this.getNextVal().then(value => {
                    this.isInsertMode = true
                    this.state.formData = {/*entry_date: new Date().toISOString().split('T')[0]*/}
                    this.state.formData.charter_agreement_code = value
                })
            }

            await this.$refs.gridDetail_serres_geo_location_facilities.instance.refresh()
            await this.$refs.gridDetail_serres_geo_locations_lang.instance.refresh()
        },

        async getNextVal() {
            //console.log('getNextVal')
            this.state.serres_geo_locations_nextval_VIEW.clearRawDataCache()
            let row = await this.state.serres_geo_locations_nextval_VIEW.load()
            return row[0].nextval
        },

        onClickSave: async function() {
            const formValidator = this.dataForm.validate();
            this.isGridValidated = true
            let formSaved = false

            if (formValidator.isValid) {
                if (!this.isInsertMode) {
                    await this.saveData()
                    formSaved = true
                } else {
                    await this.insertData()
                    formSaved = true
                }
            }

            await this.$refs.gridDetail_serres_geo_location_facilities.instance.saveEditData()
            await this.$refs.gridDetail_serres_geo_locations_lang.instance.saveEditData()

            if (this.isGridValidated && formSaved) this.$emit('closePopupEvent', true)

        },        
        onClickOpenCharter: function() {
            //this.$emit('closePopupEvent', true);
            console.log('onClickOpenCharter')
        },
        onClickClose: function() {
            this.$emit('closePopupEvent', true);
        },
        onInitNewRow(row) {
            row.data.charter_agreement_code = this.state.formData.charter_agreement_code;
        },
        onRowValidating(e) {
          this.isGridValidated = this.isGridValidated && e.isValid;
        },
        
        setMapMarker(google_map_point) {

            if (google_map_point != null) {

                const matchResult = google_map_point.match(/\(\s*(-?\d+(\.\d+)?)\s*,\s*(-?\d+(\.\d+)?)\s*\):(\d+)/);

                if (matchResult !== null) {
                    // The actual values start from index 1, since index 0 is the full match.
                    const lat = Number(matchResult[1]); // This is the latitude
                    const lng = Number(matchResult[3]); // This is the longitude (skip index 2 because it's the decimal part of latitude)
                    const zoom = Number(matchResult[5]); // This is the zoom level (skip index 4 because it's the decimal part of longitude)

                    if (!isNaN(lat) && !isNaN(lng) && !isNaN(zoom)) {
                        console.log(zoom);
                        console.log(lat);
                        console.log(lng);
                        
                        this.zoom = zoom;
                        this.centerOfMap = { lat, lng };
                        this.markers = [{
                            position: this.centerOfMap,
                        }];
                    }
                } else {
                    console.error("Λάθος μορφή ");
                }
            } else {
                console.error("Οι συντεταγμένες είναι άδειες");
            }
            
        },
        /*
        addMarker(e) {
            console.log("addMarker(e)")
            this.mapMarkers.push({ location: e.location });
        },
        removeMarker() {
          console.log("removeMarker()")
            this.mapMarkers.pop();
        },
        */
        onDragend(e) {
          let lat = e.latLng.lat()
          let lng = e.latLng.lng()
          let zoom = this.$refs.itieraryDetailMapRef.$mapObject.zoom

          if (lat) {
            //this.dataGrid.cellValue(this.rowIndex, "google_map_point", `(${lat}, ${lng}):${zoom}`);
            console.log("this.state.formData.google_map before")
            console.log(this.state.formData.google_map)

            this.$refs.formMaster.instance.getEditor('google_map').option('value', `(${lat}, ${lng}):${zoom}`)

            //this.state.formData.google_map = `(${lat}, ${lng}):${zoom}`

            console.log("this.state.formData.google_map 2 after")
            console.log(this.state.formData.google_map)
          }
          
        }
    },
    computed: {
        dataGrid_serres_geo_locations_lang: function() {
            return this.$refs.gridDetail_serres_geo_locations_lang.instance;
        },
        dataForm: function() {
            return this.$refs.formMaster.instance;
        },        
        allowDeleting() {
            return ([1, 2, 3, 22].some(id => NYParameters.loggedUser.system_user_group_ids.includes(id)))
        },
        allowAdding() {
            return ([1, 2, 3, 22].some(id => NYParameters.loggedUser.system_user_group_ids.includes(id)))
        },
        allowEditing() {
            return ([1, 2, 3, 22].some(id => NYParameters.loggedUser.system_user_group_ids.includes(id)))
        },
        allowAdministratorEditing() {
            return ([1, 2, 3, 22].some(id => NYParameters.loggedUser.system_user_group_ids.includes(id)))
        },
    }
};
</script>

<style lang="scss">

</style>

<style scoped>

/* Targets editing row */
::ng-deep .dx-edit-row {
    box-shadow: 3px 3px 5px 5px #ccc;
}

.grid-map-container {
  display: flex;
  flex-wrap: wrap;
}

.grid {
  flex: 1;
  padding: 10px;
  max-width: 50%; /* Adjust this as needed for the desired width on desktop and tablet */
  box-sizing: border-box;
}

.map {
  flex: 1;
  padding: 4% 2% 5% 2%;;
  max-width: 50%; /* Adjust this as needed for the desired width on desktop and tablet */
  box-sizing: border-box;
}

@media (max-width: 768px) {
  /* Adjust the layout for tablets (e.g., 768px) */
  .grid {
    max-width: 100%; /* Full width for tablets */
  }

  .map {
    max-width: 100%; /* Full width for tablets */
  }
}

#form {
   margin-top: 25px;
}
.caption {
    font-size: 18px;
    font-weight: 500;
}
.option {
    margin-top: 10px;
}

</style>
